import React from 'react';
import { CategoriesProxy } from '../../../services/catalogServiceAPI/categoriesProxy';
import { observer } from 'mobx-react';
import { action, makeObservable, observable } from 'mobx';
import { ItemCategory } from "./itemCategory";
import sortBy from "lodash/sortBy";
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

@observer
export class ItemCategories extends React.Component {
    categoriesProxy = new CategoriesProxy();

    @observable categories = [];

    @action.bound setCategories = (categories) => categories.forEach(category => this.categories.push(category));

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    addCategory = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.add();
    }

    async componentDidMount() {
        const categories = await this.categoriesProxy.list();
        this.setCategories(sortBy(categories, ['parentId', 'title']));
    }

    render() {
        if (this.categories.length === 0) {
            return <span style={{ color: 'rgba(255,255,255,0.45)' }}>Loading categories…</span>;
        }

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {this.props.categoriesIds.map((id, index) => (
                    <ItemCategory
                        key={id}
                        id={id}
                        index={index}
                        categories={this.categories}
                        update={this.props.update}
                        remove={this.props.remove}
                    />
                ))}
                <div>
                    <Button
                        icon={<PlusOutlined />}
                        onClick={this.addCategory}
                        size="small"
                    >
                        Add Category
                    </Button>
                </div>
            </div>
        );
    }
}
